export const ProductRowSkeleton = () => (
  <div className="flex gap-4">
    <div className="w-full bg-gray-200 rounded animate-pulse flex flex-col justify-end gap-2 p-4">
      <div className="w-full h-48 bg-gray-300 rounded animate-pulse"></div>
      <div className="flex items-center justify-center py-2">
        <div className="w-10 h-10 rounded-full bg-gray-300"></div>
      </div>
      <div className="w-full h-5 bg-gray-300 rounded animate-pulse"></div>
      <div className="w-3/4 h-5 bg-gray-300 rounded animate-pulse"></div>
    </div>
    <div className="w-full bg-gray-200 rounded animate-pulse flex flex-col justify-end gap-2 p-4">
      <div className="w-full h-48 bg-gray-300 rounded animate-pulse"></div>
      <div className="flex items-center justify-center py-2">
        <div className="w-10 h-10 rounded-full bg-gray-300"></div>
      </div>
      <div className="w-full h-5 bg-gray-300 rounded animate-pulse"></div>
      <div className="w-3/4 h-5 bg-gray-300 rounded animate-pulse"></div>
    </div>

    <div className="hidden md:flex w-full bg-gray-200 rounded animate-pulse flex-col justify-end gap-2 p-4">
      <div className="w-full h-48 bg-gray-300 rounded animate-pulse"></div>
      <div className="flex items-center justify-center py-2">
        <div className="w-10 h-10 rounded-full bg-gray-300"></div>
      </div>
      <div className="w-full h-5 bg-gray-300 rounded animate-pulse"></div>
      <div className="w-3/4 h-5 bg-gray-300 rounded animate-pulse"></div>
    </div>
    <div className="hidden lg:flex w-full bg-gray-200 rounded animate-pulse flex-col justify-end gap-2 p-4">
      <div className="w-full h-48 bg-gray-300 rounded animate-pulse"></div>
      <div className="flex items-center justify-center py-2">
        <div className="w-10 h-10 rounded-full bg-gray-300"></div>
      </div>
      <div className="w-full h-5 bg-gray-300 rounded animate-pulse"></div>
      <div className="w-3/4 h-5 bg-gray-300 rounded animate-pulse"></div>
    </div>
    <div className="hidden xl:flex w-full bg-gray-200 rounded animate-pulse flex-col justify-end gap-2 p-4">
      <div className="w-full h-48 bg-gray-300 rounded animate-pulse"></div>
      <div className="flex items-center justify-center py-2">
        <div className="w-10 h-10 rounded-full bg-gray-300"></div>
      </div>
      <div className="w-full h-5 bg-gray-300 rounded animate-pulse"></div>
      <div className="w-3/4 h-5 bg-gray-300 rounded animate-pulse"></div>
    </div>
  </div>
);

export const ProductRowSkeletonFour = () => (
  <div className="flex gap-4">
    <div className="w-full bg-gray-200 rounded animate-pulse flex flex-col justify-end gap-2 p-4">
      <div className="w-full h-48 bg-gray-300 rounded animate-pulse"></div>
      <div className="flex items-center justify-center py-2">
        <div className="w-10 h-10 rounded-full bg-gray-300"></div>
      </div>
      <div className="w-full h-5 bg-gray-300 rounded animate-pulse"></div>
      <div className="w-3/4 h-5 bg-gray-300 rounded animate-pulse"></div>
    </div>
    <div className="w-full bg-gray-200 rounded animate-pulse flex flex-col justify-end gap-2 p-4">
      <div className="w-full h-48 bg-gray-300 rounded animate-pulse"></div>
      <div className="flex items-center justify-center py-2">
        <div className="w-10 h-10 rounded-full bg-gray-300"></div>
      </div>
      <div className="w-full h-5 bg-gray-300 rounded animate-pulse"></div>
      <div className="w-3/4 h-5 bg-gray-300 rounded animate-pulse"></div>
    </div>

    <div className="hidden md:flex w-full bg-gray-200 rounded animate-pulse flex-col justify-end gap-2 p-4">
      <div className="w-full h-48 bg-gray-300 rounded animate-pulse"></div>
      <div className="flex items-center justify-center py-2">
        <div className="w-10 h-10 rounded-full bg-gray-300"></div>
      </div>
      <div className="w-full h-5 bg-gray-300 rounded animate-pulse"></div>
      <div className="w-3/4 h-5 bg-gray-300 rounded animate-pulse"></div>
    </div>
    <div className="hidden lg:flex w-full bg-gray-200 rounded animate-pulse flex-col justify-end gap-2 p-4">
      <div className="w-full h-48 bg-gray-300 rounded animate-pulse"></div>
      <div className="flex items-center justify-center py-2">
        <div className="w-10 h-10 rounded-full bg-gray-300"></div>
      </div>
      <div className="w-full h-5 bg-gray-300 rounded animate-pulse"></div>
      <div className="w-3/4 h-5 bg-gray-300 rounded animate-pulse"></div>
    </div>
  </div>
);

export const ProductColumnSkeleton = () => (
  <div className="flex min-w-[300px] max-h-[90vh] flex-col gap-4">
    <div className="w-full bg-gray-200 rounded animate-pulse flex justify-end gap-2 p-4">
      <div className="w-24 h-24 bg-gray-300 rounded animate-pulse"></div>
      <div className="w-full flex-1 flex flex-col gap-2 justify-end py-2">
        <div className="w-full h-5 bg-gray-300 rounded animate-pulse"></div>
        <div className="w-3/4 h-5 bg-gray-300 rounded animate-pulse"></div>
      </div>
    </div>
    <div className="w-full bg-gray-200 rounded animate-pulse flex justify-end gap-2 p-4">
      <div className="w-24 h-24 bg-gray-300 rounded animate-pulse"></div>
      <div className="w-full flex-1 flex flex-col gap-2 justify-end py-2">
        <div className="w-full h-5 bg-gray-300 rounded animate-pulse"></div>
        <div className="w-3/4 h-5 bg-gray-300 rounded animate-pulse"></div>
      </div>
    </div>
    <div className="w-full bg-gray-200 rounded animate-pulse flex justify-end gap-2 p-4">
      <div className="w-24 h-24 bg-gray-300 rounded animate-pulse"></div>
      <div className="w-full flex-1 flex flex-col gap-2 justify-end py-2">
        <div className="w-full h-5 bg-gray-300 rounded animate-pulse"></div>
        <div className="w-3/4 h-5 bg-gray-300 rounded animate-pulse"></div>
      </div>
    </div>
    <div className="w-full bg-gray-200 rounded animate-pulse flex justify-end gap-2 p-4">
      <div className="w-24 h-24 bg-gray-300 rounded animate-pulse"></div>
      <div className="w-full flex-1 flex flex-col gap-2 justify-end py-2">
        <div className="w-full h-5 bg-gray-300 rounded animate-pulse"></div>
        <div className="w-3/4 h-5 bg-gray-300 rounded animate-pulse"></div>
      </div>
    </div>
  </div>
);
